/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  ConversationalAgentInferencerCreatePolymorphic,
  ConversationalAgentInferencerPolymorphic,
  ConversationalAgentInferencerTestFail,
  ConversationalAgentInferencerTestOk,
  InferencerTestFail,
  InferencerTestOk,
  PaginatedConversationalAgentInferencerPolymorphicList,
  PaginatedSingleTurnChatInferencerPolymorphicList,
  PaginatedVoiceAgentInferencerPolymorphicList,
  PatchedConversationalAgentInferencerPolymorphic,
  PatchedSingleTurnChatInferencerPolymorphic,
  PatchedVoiceAgentInferencerPolymorphic,
  SingleTurnChatInferencerCreatePolymorphic,
  SingleTurnChatInferencerPolymorphic,
  VoiceAgentInferencerCreatePolymorphic,
  VoiceAgentInferencerPolymorphic,
  VoiceAgentInferencerTestFail,
  VoiceAgentInferencerTestOk,
} from '../models/index';
import {
  ConversationalAgentInferencerCreatePolymorphicFromJSON,
  ConversationalAgentInferencerCreatePolymorphicToJSON,
  ConversationalAgentInferencerPolymorphicFromJSON,
  ConversationalAgentInferencerPolymorphicToJSON,
  ConversationalAgentInferencerTestFailFromJSON,
  ConversationalAgentInferencerTestFailToJSON,
  ConversationalAgentInferencerTestOkFromJSON,
  ConversationalAgentInferencerTestOkToJSON,
  InferencerTestFailFromJSON,
  InferencerTestFailToJSON,
  InferencerTestOkFromJSON,
  InferencerTestOkToJSON,
  PaginatedConversationalAgentInferencerPolymorphicListFromJSON,
  PaginatedConversationalAgentInferencerPolymorphicListToJSON,
  PaginatedSingleTurnChatInferencerPolymorphicListFromJSON,
  PaginatedSingleTurnChatInferencerPolymorphicListToJSON,
  PaginatedVoiceAgentInferencerPolymorphicListFromJSON,
  PaginatedVoiceAgentInferencerPolymorphicListToJSON,
  PatchedConversationalAgentInferencerPolymorphicFromJSON,
  PatchedConversationalAgentInferencerPolymorphicToJSON,
  PatchedSingleTurnChatInferencerPolymorphicFromJSON,
  PatchedSingleTurnChatInferencerPolymorphicToJSON,
  PatchedVoiceAgentInferencerPolymorphicFromJSON,
  PatchedVoiceAgentInferencerPolymorphicToJSON,
  SingleTurnChatInferencerCreatePolymorphicFromJSON,
  SingleTurnChatInferencerCreatePolymorphicToJSON,
  SingleTurnChatInferencerPolymorphicFromJSON,
  SingleTurnChatInferencerPolymorphicToJSON,
  VoiceAgentInferencerCreatePolymorphicFromJSON,
  VoiceAgentInferencerCreatePolymorphicToJSON,
  VoiceAgentInferencerPolymorphicFromJSON,
  VoiceAgentInferencerPolymorphicToJSON,
  VoiceAgentInferencerTestFailFromJSON,
  VoiceAgentInferencerTestFailToJSON,
  VoiceAgentInferencerTestOkFromJSON,
  VoiceAgentInferencerTestOkToJSON,
} from '../models/index';

export interface ApiInferencersConversationalAgentCreateRequest {
  conversationalAgentInferencerCreatePolymorphic?: ConversationalAgentInferencerCreatePolymorphic;
}

export interface ApiInferencersConversationalAgentDestroyRequest {
  id: number;
}

export interface ApiInferencersConversationalAgentListRequest {
  name?: string;
  page?: number;
  pageSize?: number;
  protocol?: Array<ApiInferencersConversationalAgentListProtocolEnum>;
}

export interface ApiInferencersConversationalAgentPartialUpdateRequest {
  id: number;
  patchedConversationalAgentInferencerPolymorphic?: PatchedConversationalAgentInferencerPolymorphic;
}

export interface ApiInferencersConversationalAgentRetrieveRequest {
  id: number;
}

export interface ApiInferencersConversationalAgentTestCreateRequest {
  conversationalAgentInferencerCreatePolymorphic?: ConversationalAgentInferencerCreatePolymorphic;
}

export interface ApiInferencersConversationalAgentUpdateRequest {
  id: number;
  conversationalAgentInferencerPolymorphic?: ConversationalAgentInferencerPolymorphic;
}

export interface ApiInferencersSingleTurnChatCreateRequest {
  singleTurnChatInferencerCreatePolymorphic?: SingleTurnChatInferencerCreatePolymorphic;
}

export interface ApiInferencersSingleTurnChatDestroyRequest {
  id: number;
}

export interface ApiInferencersSingleTurnChatListRequest {
  name?: string;
  page?: number;
  pageSize?: number;
  protocol?: Array<ApiInferencersSingleTurnChatListProtocolEnum>;
}

export interface ApiInferencersSingleTurnChatPartialUpdateRequest {
  id: number;
  patchedSingleTurnChatInferencerPolymorphic?: PatchedSingleTurnChatInferencerPolymorphic;
}

export interface ApiInferencersSingleTurnChatRetrieveRequest {
  id: number;
}

export interface ApiInferencersSingleTurnChatTestCreateRequest {
  singleTurnChatInferencerCreatePolymorphic?: SingleTurnChatInferencerCreatePolymorphic;
}

export interface ApiInferencersSingleTurnChatUpdateRequest {
  id: number;
  singleTurnChatInferencerPolymorphic?: SingleTurnChatInferencerPolymorphic;
}

export interface ApiInferencersVoiceAgentCreateRequest {
  voiceAgentInferencerCreatePolymorphic?: VoiceAgentInferencerCreatePolymorphic;
}

export interface ApiInferencersVoiceAgentDestroyRequest {
  id: number;
}

export interface ApiInferencersVoiceAgentListRequest {
  name?: string;
  page?: number;
  pageSize?: number;
  protocol?: Array<ApiInferencersVoiceAgentListProtocolEnum>;
}

export interface ApiInferencersVoiceAgentPartialUpdateRequest {
  id: number;
  patchedVoiceAgentInferencerPolymorphic?: PatchedVoiceAgentInferencerPolymorphic;
}

export interface ApiInferencersVoiceAgentRetrieveRequest {
  id: number;
}

export interface ApiInferencersVoiceAgentTestCreateRequest {
  voiceAgentInferencerCreatePolymorphic?: VoiceAgentInferencerCreatePolymorphic;
}

export interface ApiInferencersVoiceAgentUpdateRequest {
  id: number;
  voiceAgentInferencerPolymorphic?: VoiceAgentInferencerPolymorphic;
}

export interface InferencersListRequest {
  taskType?: InferencersListTaskTypeEnum;
}

export interface InferencersList2Request {
  id: string;
}

export interface InferencersList3Request {
  id: string;
}

/**
 *
 */
export class InferencersApi extends runtime.BaseAPI {
  /**
   * Full CRUD for conversational agent inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersConversationalAgentCreateRaw(
    requestParameters: ApiInferencersConversationalAgentCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ConversationalAgentInferencerPolymorphic>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/inferencers/conversational-agent/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ConversationalAgentInferencerCreatePolymorphicToJSON(
          requestParameters['conversationalAgentInferencerCreatePolymorphic'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ConversationalAgentInferencerPolymorphicFromJSON(jsonValue),
    );
  }

  /**
   * Full CRUD for conversational agent inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersConversationalAgentCreate(
    requestParameters: ApiInferencersConversationalAgentCreateRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ConversationalAgentInferencerPolymorphic> {
    const response = await this.apiInferencersConversationalAgentCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Full CRUD for conversational agent inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersConversationalAgentDestroyRaw(
    requestParameters: ApiInferencersConversationalAgentDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiInferencersConversationalAgentDestroy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/inferencers/conversational-agent/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Full CRUD for conversational agent inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersConversationalAgentDestroy(
    requestParameters: ApiInferencersConversationalAgentDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiInferencersConversationalAgentDestroyRaw(requestParameters, initOverrides);
  }

  /**
   * Full CRUD for conversational agent inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersConversationalAgentListRaw(
    requestParameters: ApiInferencersConversationalAgentListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedConversationalAgentInferencerPolymorphicList>> {
    const queryParameters: any = {};

    if (requestParameters['name'] != null) {
      queryParameters['name'] = requestParameters['name'];
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    if (requestParameters['protocol'] != null) {
      queryParameters['protocol'] = requestParameters['protocol'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/inferencers/conversational-agent/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PaginatedConversationalAgentInferencerPolymorphicListFromJSON(jsonValue),
    );
  }

  /**
   * Full CRUD for conversational agent inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersConversationalAgentList(
    requestParameters: ApiInferencersConversationalAgentListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedConversationalAgentInferencerPolymorphicList> {
    const response = await this.apiInferencersConversationalAgentListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Full CRUD for conversational agent inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersConversationalAgentPartialUpdateRaw(
    requestParameters: ApiInferencersConversationalAgentPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ConversationalAgentInferencerPolymorphic>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiInferencersConversationalAgentPartialUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/inferencers/conversational-agent/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PatchedConversationalAgentInferencerPolymorphicToJSON(
          requestParameters['patchedConversationalAgentInferencerPolymorphic'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ConversationalAgentInferencerPolymorphicFromJSON(jsonValue),
    );
  }

  /**
   * Full CRUD for conversational agent inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersConversationalAgentPartialUpdate(
    requestParameters: ApiInferencersConversationalAgentPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ConversationalAgentInferencerPolymorphic> {
    const response = await this.apiInferencersConversationalAgentPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Full CRUD for conversational agent inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersConversationalAgentRetrieveRaw(
    requestParameters: ApiInferencersConversationalAgentRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ConversationalAgentInferencerPolymorphic>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiInferencersConversationalAgentRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/inferencers/conversational-agent/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ConversationalAgentInferencerPolymorphicFromJSON(jsonValue),
    );
  }

  /**
   * Full CRUD for conversational agent inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersConversationalAgentRetrieve(
    requestParameters: ApiInferencersConversationalAgentRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ConversationalAgentInferencerPolymorphic> {
    const response = await this.apiInferencersConversationalAgentRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Validates the supplied inferencer configuration and performs a lightweight connectivity check against the remote service without persisting anything. Accepts the same payload as ``POST /api/inferencers/conversational-agent/``. Returns ``{\"success\": true}`` on success or ``{\"success\": false, \"error\": \"...\"}`` with HTTP 502 on failure.
   * Test inferencer connectivity
   */
  async apiInferencersConversationalAgentTestCreateRaw(
    requestParameters: ApiInferencersConversationalAgentTestCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ConversationalAgentInferencerTestOk>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/inferencers/conversational-agent/test/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ConversationalAgentInferencerCreatePolymorphicToJSON(
          requestParameters['conversationalAgentInferencerCreatePolymorphic'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => ConversationalAgentInferencerTestOkFromJSON(jsonValue));
  }

  /**
   * Validates the supplied inferencer configuration and performs a lightweight connectivity check against the remote service without persisting anything. Accepts the same payload as ``POST /api/inferencers/conversational-agent/``. Returns ``{\"success\": true}`` on success or ``{\"success\": false, \"error\": \"...\"}`` with HTTP 502 on failure.
   * Test inferencer connectivity
   */
  async apiInferencersConversationalAgentTestCreate(
    requestParameters: ApiInferencersConversationalAgentTestCreateRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ConversationalAgentInferencerTestOk> {
    const response = await this.apiInferencersConversationalAgentTestCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Full CRUD for conversational agent inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersConversationalAgentUpdateRaw(
    requestParameters: ApiInferencersConversationalAgentUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ConversationalAgentInferencerPolymorphic>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiInferencersConversationalAgentUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/inferencers/conversational-agent/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: ConversationalAgentInferencerPolymorphicToJSON(
          requestParameters['conversationalAgentInferencerPolymorphic'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ConversationalAgentInferencerPolymorphicFromJSON(jsonValue),
    );
  }

  /**
   * Full CRUD for conversational agent inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersConversationalAgentUpdate(
    requestParameters: ApiInferencersConversationalAgentUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ConversationalAgentInferencerPolymorphic> {
    const response = await this.apiInferencersConversationalAgentUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Full CRUD for single-turn-chat inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersSingleTurnChatCreateRaw(
    requestParameters: ApiInferencersSingleTurnChatCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SingleTurnChatInferencerPolymorphic>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/inferencers/single_turn_chat/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: SingleTurnChatInferencerCreatePolymorphicToJSON(
          requestParameters['singleTurnChatInferencerCreatePolymorphic'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => SingleTurnChatInferencerPolymorphicFromJSON(jsonValue));
  }

  /**
   * Full CRUD for single-turn-chat inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersSingleTurnChatCreate(
    requestParameters: ApiInferencersSingleTurnChatCreateRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SingleTurnChatInferencerPolymorphic> {
    const response = await this.apiInferencersSingleTurnChatCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Full CRUD for single-turn-chat inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersSingleTurnChatDestroyRaw(
    requestParameters: ApiInferencersSingleTurnChatDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiInferencersSingleTurnChatDestroy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/inferencers/single_turn_chat/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Full CRUD for single-turn-chat inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersSingleTurnChatDestroy(
    requestParameters: ApiInferencersSingleTurnChatDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiInferencersSingleTurnChatDestroyRaw(requestParameters, initOverrides);
  }

  /**
   * Full CRUD for single-turn-chat inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersSingleTurnChatListRaw(
    requestParameters: ApiInferencersSingleTurnChatListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedSingleTurnChatInferencerPolymorphicList>> {
    const queryParameters: any = {};

    if (requestParameters['name'] != null) {
      queryParameters['name'] = requestParameters['name'];
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    if (requestParameters['protocol'] != null) {
      queryParameters['protocol'] = requestParameters['protocol'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/inferencers/single_turn_chat/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PaginatedSingleTurnChatInferencerPolymorphicListFromJSON(jsonValue),
    );
  }

  /**
   * Full CRUD for single-turn-chat inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersSingleTurnChatList(
    requestParameters: ApiInferencersSingleTurnChatListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedSingleTurnChatInferencerPolymorphicList> {
    const response = await this.apiInferencersSingleTurnChatListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Full CRUD for single-turn-chat inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersSingleTurnChatPartialUpdateRaw(
    requestParameters: ApiInferencersSingleTurnChatPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SingleTurnChatInferencerPolymorphic>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiInferencersSingleTurnChatPartialUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/inferencers/single_turn_chat/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PatchedSingleTurnChatInferencerPolymorphicToJSON(
          requestParameters['patchedSingleTurnChatInferencerPolymorphic'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => SingleTurnChatInferencerPolymorphicFromJSON(jsonValue));
  }

  /**
   * Full CRUD for single-turn-chat inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersSingleTurnChatPartialUpdate(
    requestParameters: ApiInferencersSingleTurnChatPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SingleTurnChatInferencerPolymorphic> {
    const response = await this.apiInferencersSingleTurnChatPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Full CRUD for single-turn-chat inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersSingleTurnChatRetrieveRaw(
    requestParameters: ApiInferencersSingleTurnChatRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SingleTurnChatInferencerPolymorphic>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiInferencersSingleTurnChatRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/inferencers/single_turn_chat/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => SingleTurnChatInferencerPolymorphicFromJSON(jsonValue));
  }

  /**
   * Full CRUD for single-turn-chat inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersSingleTurnChatRetrieve(
    requestParameters: ApiInferencersSingleTurnChatRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SingleTurnChatInferencerPolymorphic> {
    const response = await this.apiInferencersSingleTurnChatRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Validates the supplied inferencer configuration and performs a lightweight connectivity check against the remote service without persisting anything. Accepts the same payload as ``POST /api/inferencers/rag/``. Returns ``{\"success\": true}`` on success or ``{\"success\": false, \"error\": \"...\"}`` with HTTP 502 on failure.
   * Test inferencer connectivity
   */
  async apiInferencersSingleTurnChatTestCreateRaw(
    requestParameters: ApiInferencersSingleTurnChatTestCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<InferencerTestOk>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/inferencers/single_turn_chat/test/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: SingleTurnChatInferencerCreatePolymorphicToJSON(
          requestParameters['singleTurnChatInferencerCreatePolymorphic'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => InferencerTestOkFromJSON(jsonValue));
  }

  /**
   * Validates the supplied inferencer configuration and performs a lightweight connectivity check against the remote service without persisting anything. Accepts the same payload as ``POST /api/inferencers/rag/``. Returns ``{\"success\": true}`` on success or ``{\"success\": false, \"error\": \"...\"}`` with HTTP 502 on failure.
   * Test inferencer connectivity
   */
  async apiInferencersSingleTurnChatTestCreate(
    requestParameters: ApiInferencersSingleTurnChatTestCreateRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<InferencerTestOk> {
    const response = await this.apiInferencersSingleTurnChatTestCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Full CRUD for single-turn-chat inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersSingleTurnChatUpdateRaw(
    requestParameters: ApiInferencersSingleTurnChatUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SingleTurnChatInferencerPolymorphic>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiInferencersSingleTurnChatUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/inferencers/single_turn_chat/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: SingleTurnChatInferencerPolymorphicToJSON(requestParameters['singleTurnChatInferencerPolymorphic']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => SingleTurnChatInferencerPolymorphicFromJSON(jsonValue));
  }

  /**
   * Full CRUD for single-turn-chat inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersSingleTurnChatUpdate(
    requestParameters: ApiInferencersSingleTurnChatUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SingleTurnChatInferencerPolymorphic> {
    const response = await this.apiInferencersSingleTurnChatUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Full CRUD for voice agent inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersVoiceAgentCreateRaw(
    requestParameters: ApiInferencersVoiceAgentCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<VoiceAgentInferencerPolymorphic>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/inferencers/voice-agent/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: VoiceAgentInferencerCreatePolymorphicToJSON(requestParameters['voiceAgentInferencerCreatePolymorphic']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => VoiceAgentInferencerPolymorphicFromJSON(jsonValue));
  }

  /**
   * Full CRUD for voice agent inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersVoiceAgentCreate(
    requestParameters: ApiInferencersVoiceAgentCreateRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<VoiceAgentInferencerPolymorphic> {
    const response = await this.apiInferencersVoiceAgentCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Full CRUD for voice agent inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersVoiceAgentDestroyRaw(
    requestParameters: ApiInferencersVoiceAgentDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiInferencersVoiceAgentDestroy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/inferencers/voice-agent/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Full CRUD for voice agent inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersVoiceAgentDestroy(
    requestParameters: ApiInferencersVoiceAgentDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiInferencersVoiceAgentDestroyRaw(requestParameters, initOverrides);
  }

  /**
   * Full CRUD for voice agent inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersVoiceAgentListRaw(
    requestParameters: ApiInferencersVoiceAgentListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedVoiceAgentInferencerPolymorphicList>> {
    const queryParameters: any = {};

    if (requestParameters['name'] != null) {
      queryParameters['name'] = requestParameters['name'];
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    if (requestParameters['protocol'] != null) {
      queryParameters['protocol'] = requestParameters['protocol'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/inferencers/voice-agent/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PaginatedVoiceAgentInferencerPolymorphicListFromJSON(jsonValue),
    );
  }

  /**
   * Full CRUD for voice agent inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersVoiceAgentList(
    requestParameters: ApiInferencersVoiceAgentListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedVoiceAgentInferencerPolymorphicList> {
    const response = await this.apiInferencersVoiceAgentListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Full CRUD for voice agent inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersVoiceAgentPartialUpdateRaw(
    requestParameters: ApiInferencersVoiceAgentPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<VoiceAgentInferencerPolymorphic>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiInferencersVoiceAgentPartialUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/inferencers/voice-agent/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PatchedVoiceAgentInferencerPolymorphicToJSON(requestParameters['patchedVoiceAgentInferencerPolymorphic']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => VoiceAgentInferencerPolymorphicFromJSON(jsonValue));
  }

  /**
   * Full CRUD for voice agent inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersVoiceAgentPartialUpdate(
    requestParameters: ApiInferencersVoiceAgentPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<VoiceAgentInferencerPolymorphic> {
    const response = await this.apiInferencersVoiceAgentPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Full CRUD for voice agent inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersVoiceAgentRetrieveRaw(
    requestParameters: ApiInferencersVoiceAgentRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<VoiceAgentInferencerPolymorphic>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiInferencersVoiceAgentRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/inferencers/voice-agent/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => VoiceAgentInferencerPolymorphicFromJSON(jsonValue));
  }

  /**
   * Full CRUD for voice agent inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersVoiceAgentRetrieve(
    requestParameters: ApiInferencersVoiceAgentRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<VoiceAgentInferencerPolymorphic> {
    const response = await this.apiInferencersVoiceAgentRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Validates the supplied inferencer configuration and performs a lightweight connectivity check against the remote service without persisting anything. Accepts the same payload as ``POST /api/inferencers/voice-agent/``. Returns ``{\"success\": true}`` on success or ``{\"success\": false, \"error\": \"...\"}`` with HTTP 502 on failure.
   * Test inferencer connectivity
   */
  async apiInferencersVoiceAgentTestCreateRaw(
    requestParameters: ApiInferencersVoiceAgentTestCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<VoiceAgentInferencerTestOk>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/inferencers/voice-agent/test/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: VoiceAgentInferencerCreatePolymorphicToJSON(requestParameters['voiceAgentInferencerCreatePolymorphic']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => VoiceAgentInferencerTestOkFromJSON(jsonValue));
  }

  /**
   * Validates the supplied inferencer configuration and performs a lightweight connectivity check against the remote service without persisting anything. Accepts the same payload as ``POST /api/inferencers/voice-agent/``. Returns ``{\"success\": true}`` on success or ``{\"success\": false, \"error\": \"...\"}`` with HTTP 502 on failure.
   * Test inferencer connectivity
   */
  async apiInferencersVoiceAgentTestCreate(
    requestParameters: ApiInferencersVoiceAgentTestCreateRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<VoiceAgentInferencerTestOk> {
    const response = await this.apiInferencersVoiceAgentTestCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Full CRUD for voice agent inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersVoiceAgentUpdateRaw(
    requestParameters: ApiInferencersVoiceAgentUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<VoiceAgentInferencerPolymorphic>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiInferencersVoiceAgentUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/inferencers/voice-agent/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: VoiceAgentInferencerPolymorphicToJSON(requestParameters['voiceAgentInferencerPolymorphic']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => VoiceAgentInferencerPolymorphicFromJSON(jsonValue));
  }

  /**
   * Full CRUD for voice agent inferencers. Inferencers are named, saved inference configurations reusable across dataset creation flows. ``protocol`` and ``task_type`` are immutable after creation — use PATCH to update ``name`` and other type-specific inputs.
   */
  async apiInferencersVoiceAgentUpdate(
    requestParameters: ApiInferencersVoiceAgentUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<VoiceAgentInferencerPolymorphic> {
    const response = await this.apiInferencersVoiceAgentUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Polymorphic inferencer list across all task types. Use ``task_type`` query param to filter (e.g. ``?task_type=rag``). Each item includes a ``task_type`` discriminator field.
   * List inferencers (all task types)
   */
  async inferencersListRaw(
    requestParameters: InferencersListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    const queryParameters: any = {};

    if (requestParameters['taskType'] != null) {
      queryParameters['task_type'] = requestParameters['taskType'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/inferencers/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Polymorphic inferencer list across all task types. Use ``task_type`` query param to filter (e.g. ``?task_type=rag``). Each item includes a ``task_type`` discriminator field.
   * List inferencers (all task types)
   */
  async inferencersList(
    requestParameters: InferencersListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.inferencersListRaw(requestParameters, initOverrides);
  }

  /**
   * Polymorphic inferencer list across all task types. Use ``task_type`` query param to filter (e.g. ``?task_type=rag``). Each item includes a ``task_type`` discriminator field.
   * List inferencers (all task types)
   */
  async inferencersList2Raw(
    requestParameters: InferencersList2Request,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling inferencersList2().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/inferencers/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Polymorphic inferencer list across all task types. Use ``task_type`` query param to filter (e.g. ``?task_type=rag``). Each item includes a ``task_type`` discriminator field.
   * List inferencers (all task types)
   */
  async inferencersList2(
    requestParameters: InferencersList2Request,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.inferencersList2Raw(requestParameters, initOverrides);
  }

  /**
   * Polymorphic inferencer list across all task types. Use ``task_type`` query param to filter (e.g. ``?task_type=rag``). Each item includes a ``task_type`` discriminator field.
   * List inferencers (all task types)
   */
  async inferencersList3Raw(
    requestParameters: InferencersList3Request,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling inferencersList3().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/inferencers/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Polymorphic inferencer list across all task types. Use ``task_type`` query param to filter (e.g. ``?task_type=rag``). Each item includes a ``task_type`` discriminator field.
   * List inferencers (all task types)
   */
  async inferencersList3(
    requestParameters: InferencersList3Request,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.inferencersList3Raw(requestParameters, initOverrides);
  }
}

/**
 * @export
 */
export const ApiInferencersConversationalAgentListProtocolEnum = {
  celina: 'CELINA',
  openAiAssistant: 'OPEN_AI_ASSISTANT',
} as const;
export type ApiInferencersConversationalAgentListProtocolEnum =
  (typeof ApiInferencersConversationalAgentListProtocolEnum)[keyof typeof ApiInferencersConversationalAgentListProtocolEnum];
/**
 * @export
 */
export const ApiInferencersSingleTurnChatListProtocolEnum = {
  aino: 'AINO',
  azureOpenAiAssistant: 'AZURE_OPEN_AI_ASSISTANT',
  customApi: 'CUSTOM_API',
  openAiAssistant: 'OPEN_AI_ASSISTANT',
  poe: 'POE',
  spitch: 'SPITCH',
} as const;
export type ApiInferencersSingleTurnChatListProtocolEnum =
  (typeof ApiInferencersSingleTurnChatListProtocolEnum)[keyof typeof ApiInferencersSingleTurnChatListProtocolEnum];
/**
 * @export
 */
export const ApiInferencersVoiceAgentListProtocolEnum = {
  celina: 'CELINA',
  livekit: 'LIVEKIT',
} as const;
export type ApiInferencersVoiceAgentListProtocolEnum =
  (typeof ApiInferencersVoiceAgentListProtocolEnum)[keyof typeof ApiInferencersVoiceAgentListProtocolEnum];
/**
 * @export
 */
export const InferencersListTaskTypeEnum = {
  conversationalAgent: 'conversational_agent',
  singleTurnChat: 'single_turn_chat',
  voiceAgent: 'voice_agent',
} as const;
export type InferencersListTaskTypeEnum =
  (typeof InferencersListTaskTypeEnum)[keyof typeof InferencersListTaskTypeEnum];
